import { render, staticRenderFns } from "./adddepartment.vue?vue&type=template&id=6b8778b0&scoped=true&"
import script from "./adddepartment.vue?vue&type=script&lang=js&"
export * from "./adddepartment.vue?vue&type=script&lang=js&"
import style0 from "./adddepartment.vue?vue&type=style&index=0&id=6b8778b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8778b0",
  null
  
)

export default component.exports